import {atom} from 'jotai';

const authMenusAtom = atom([]);

export {authMenusAtom};
